import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useUserContext } from "../UserProvider";

export const Onboarding = () => {
  const { userSummaries } = useUserContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if user is on the root onboarding path (not on manual restart)
    // This allows the help icon to work while still redirecting users who land on /onboarding directly
    if (location.pathname === "/onboarding" && userSummaries && userSummaries.length > 0) {
      navigate("/", { replace: true });
    }
  }, [userSummaries, location.pathname, navigate]);

  return <Outlet />;
};

export default Onboarding;
